import React, { useEffect, useState } from "react";
import "./top.css";

export default function Top({ item, user }) {
  return (
    <div className="top">
      <div className="top-inner">
        {item === 1 ? (
          <Skills user={user} />
        ) : item === 2 ? (
          <Work user={user} />
        ) : item === 3 ? (
          <Edu user={user} />
        ) : (
          <Name />
        )}
      </div>
    </div>
  );
}

function Name() {
  useEffect(() => {
    document.querySelectorAll(".name-item").forEach((item) => {
      item.style.top = "0px";
      item.style.left = "0px";
    });
  }, []);

  return (
    <div className="top-name">
      <div className="top-name-inner">
        <div className="name-item" id="name-item-1">
          A
        </div>
        <div className="name-item" id="name-item-2">
          R
        </div>
        <div className="name-item" id="name-item-3">
          M
        </div>
        <div className="name-item" id="name-item-4">
          A
        </div>
        <div className="name-item" id="name-item-5">
          A
        </div>
        <div className="name-item" id="name-item-6">
          N
        </div>
        <div className="name-item" id="name-item-7"></div>
        <div className="name-item" id="name-item-8">
          A
        </div>
        <div className="name-item" id="name-item-9">
          G
        </div>
        <div className="name-item" id="name-item-10">
          R
        </div>
        <div className="name-item" id="name-item-11">
          A
        </div>
        <div className="name-item" id="name-item-12">
          W
        </div>
        <div className="name-item" id="name-item-13">
          A
        </div>
        <div className="name-item" id="name-item-14">
          L
        </div>
      </div>
    </div>
  );
}

function Skills({ user }) {
  return (
    <div className="xyz">
      <div className="xyz-bg">
        <div className="work-black2"></div>
        <img src={user.skill_bg_img}></img>
      </div>
      <div className="xyz-title">Technical Proficiencies</div>
      <div className="skills">
        <div className="skills-slide">
          {user.skills.map((item, index) => (
            <div className="skill-item">
              <img src={item.icon}></img>
              <div className="skill-shadow"></div>
              <div>{item.name}</div>
            </div>
          ))}
        </div>
        <div className="skills-slide">
          {user.skills.map((item, index) => (
            <div className="skill-item">
              <img src={item.icon}></img>
              <div className="skill-shadow"></div>
              <div>{item.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Work({ user }) {
  const [item, setItem] = useState(0);
  const [mouse, setMouse] = useState(false);

  const size = user.work_experience.length;

  function left() {
    setItem((((item - 1) % size) + size) % size);
    document.querySelector(`.edu-${item}`).style.left = "100%";
    document.querySelector(
      `.edu-${(((item - 1) % size) + size) % size}`
    ).style.transition = "0s";
    document.querySelector(
      `.edu-${(((item - 1) % size) + size) % size}`
    ).style.left = "-100%";
    setTimeout(() => {
      document.querySelector(
        `.edu-${(((item - 1) % size) + size) % size}`
      ).style.transition = "0.3s";
      document.querySelector(
        `.edu-${(((item - 1) % size) + size) % size}`
      ).style.left = "0%";
    }, 0);
  }

  function right() {
    setItem((item + 1) % size);
    document.querySelector(`.edu-${item}`).style.transition = "0.3s";
    document.querySelector(`.edu-${item}`).style.left = "-100%";
    setTimeout(() => {
      document.querySelector(`.edu-${item % size}`).style.transition = "0s";
      document.querySelector(`.edu-${item % size}`).style.left = "100%";
    }, 300);
    document.querySelector(`.edu-${(item + 1) % size}`).style.transition =
      "0.3s";
    document.querySelector(`.edu-${(item + 1) % size}`).style.left = "0%";
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (!mouse) {
        right();
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [item, mouse]);

  return (
    <div
      className="edu"
      onMouseEnter={() => {
        setMouse(true);
      }}
      onMouseLeave={() => {
        setMouse(false);
      }}
    >
      <div
        className="edu-left-arrow"
        onClick={() => {
          left();
        }}
      >
        <i class="fa-solid fa-chevron-left"></i>
      </div>
      <div
        className="edu-right-arrow"
        onClick={() => {
          right();
        }}
      >
        <i class="fa-solid fa-chevron-right"></i>
      </div>
      {user.work_experience.map((item, index) => (
        <div className={`edu-${index} edu-item`}>
          <img src={item.bg_img} alt=""></img>
          <div className="work-black">
            <div className="degree">{item.role}</div>
            <div className="work-company">
              @{item.org}, {item.loc} ({item.duration})
            </div>
            <div className="separator" />

            <div className="edu-info">
              <div className="job-desc">
                <b className="goldenrod">Roles & Responsibilities:</b>{" "}
                {item.resp}
              </div>
              <div className="work-tech">
                <b className="goldenrod">Working Technologies:</b>{" "}
                {item.tech.map((tech, index) => (
                  <span>
                    {tech} {index !== item.tech.length - 1 && " | "}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="edu-dots">
        {user.work_experience.map((i, index) => (
          <div
            className="edu-dot"
            style={{
              width: item === index ? "20px" : "5px",
              backgroundColor: item === index ? "white" : "silver",
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}

function Edu({ user }) {
  const [item, setItem] = useState(0);
  const [mouse, setMouse] = useState(false);

  const size = user.education.length;

  function left() {
    setItem((((item - 1) % size) + size) % size);
    document.querySelector(`.edu-${item}`).style.left = "100%";
    document.querySelector(
      `.edu-${(((item - 1) % size) + size) % size}`
    ).style.transition = "0s";
    document.querySelector(
      `.edu-${(((item - 1) % size) + size) % size}`
    ).style.left = "-100%";
    setTimeout(() => {
      document.querySelector(
        `.edu-${(((item - 1) % size) + size) % size}`
      ).style.transition = "0.3s";
      document.querySelector(
        `.edu-${(((item - 1) % size) + size) % size}`
      ).style.left = "0%";
    }, 0);
  }

  function right() {
    setItem((item + 1) % size);
    document.querySelector(`.edu-${item}`).style.transition = "0.3s";
    document.querySelector(`.edu-${item}`).style.left = "-100%";
    setTimeout(() => {
      document.querySelector(`.edu-${item % size}`).style.transition = "0s";
      document.querySelector(`.edu-${item % size}`).style.left = "100%";
    }, 300);
    document.querySelector(`.edu-${(item + 1) % size}`).style.transition =
      "0.3s";
    document.querySelector(`.edu-${(item + 1) % size}`).style.left = "0%";
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (!mouse) {
        right();
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [item, mouse]);

  return (
    <div
      className="edu"
      onMouseEnter={() => {
        console.log(mouse);
        setMouse(true);
      }}
      onMouseLeave={() => {
        console.log(mouse);
        setMouse(false);
      }}
    >
      <div
        className="edu-left-arrow"
        onClick={() => {
          left();
        }}
      ><i class="fa-solid fa-chevron-left"></i></div>
      <div
        className="edu-right-arrow"
        onClick={() => {
          right();
        }}
      >
        <i class="fa-solid fa-chevron-right"></i>
      </div>
      {user.education.map((item, index) => (
        <div className={`edu-${index} edu-item`}>
          <img src={item.bg_img} alt=""></img>
          <div className="edu-black">
            <div className="degree">{item.course}</div>
            <div className="duration">{item.duration}</div>
            <div className="separator" />
            <div className="edu-info">
              <div className="university">
                <b className="goldenrod">Institute:</b> {item.institute}
              </div>
              <div className="location">
                <b className="goldenrod">Location:</b> {item.loc}
              </div>
              <div className="result">
                <b className="goldenrod">Qualified with:</b>{" "}
                {item.qualified_with}
              </div>
              <div className="course">
                <b className="goldenrod">
                  {item.specialization ? "Specialization: " : "Subjects: "}
                </b>{" "}
                {item.specialization || item.subjects}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="edu-dots">
        {user.education.map((i, index) => (
          <div
            className="edu-dot"
            style={{
              width: item === index ? "20px" : "5px",
              backgroundColor: item === index ? "white" : "silver",
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}
